import React, {useState, useEffect, useContext} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { CardPerso, AddItemToList, ArticleListAssociationForm } from "@gull";
import { IsAuthContext } from 'app/App';
import axios from 'axios'
import swal from "sweetalert2";

const DuplicateSupplementListConfig = (props) => {
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);
    const [mode,setMode]=useState('filter')
    const [showAccordion,setShowAccordion]=useState(true)
    // customInterface propre au filtre articles ('filtreArticle') : props.customInterface vient de la fiche article
    // et concerne une autre interface (les champs de la fiche), pas les filtres de sélection multiple
    const [filterCustomInterface,setFilterCustomInterface]=useState({})

    const moduleErp = authParam.modules.find(value=>value.name=='erp')
    const articleListModuleActive = moduleErp.params.hasOwnProperty('article_list') && moduleErp.params.article_list.active

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/custom_interface/filtreArticle"
            ).then((response) => {
                setFilterCustomInterface({user_conf:response.data.user_conf,default_conf:response.data.default_conf})
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
        })()
    }, [])

    const handleSubmitArticleListe = async (obj,setValidButton,resetFiltreItemsToPromo,setShowModalAdd) =>{
        setValidButton(true)

        const response = await axios.post(process.env.REACT_APP_API_URL+"api/erp/supplement_list/duplicate_configuration/"+props.articleId, obj
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else {
                swal.fire({
                    icon: 'success',
                    title: t('successOperation')
                })
                if(resetFiltreItemsToPromo) resetFiltreItemsToPromo()
                setValidButton(false)
                if(setShowModalAdd) setShowModalAdd(false)
                if(props.onSuccess) props.onSuccess()
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let messageError = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(messageError), "", "error");
            setValidButton(false)
        })
    }

    return (
        <CardPerso header={t('duplicateSupplementConfig')}>
            <div className="form-group mb-3">
                <select className="form-control w-auto" value={mode} onChange={(e)=>setMode(e.target.value)}>
                    <option value="filter">{t('filterArticlesMode')}</option>
                    {articleListModuleActive && <option value="articleList">{t('existingArticleListMode')}</option>}
                </select>
            </div>

            {(mode=='articleList' && articleListModuleActive) &&
                <ArticleListAssociationForm
                    url={"api/erp/supplement_list/duplicate_configuration/"+props.articleId}
                    onSuccess={props.onSuccess}
                />
            }

            {(mode=='filter' && showAccordion) &&
                <AddItemToList
                    liaisons={props.liaisons}
                    customFields={props.customFields}
                    setToast={props.setToast}
                    customInterface={filterCustomInterface}
                    setCustomInterface={setFilterCustomInterface}
                    setReload={props.onSuccess}
                    setShowAccordion={setShowAccordion}
                    tableName={"baseDuplicateSupplementListConfig"}
                    from='supplementListDuplicateConfig'
                    handleSubmitArticleListe={handleSubmitArticleListe}
                />
            }
        </CardPerso>
    );
}

export default DuplicateSupplementListConfig;
